import {templateModelReducer} from '../../helpers/template-model-reducer';
import AlEmailTemplateEditorBeefreeModalController from './controllers/beefree-modal-controller';
import beefreeModalTemplate from './views/beefree-modal.tpl.html';
import templatePreviewLoader from '../../helpers/template-preview-loader';
import templatePreviewStarter from '../../helpers/template-preview-starter';

export default class AlEmailTemplateEditorController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.modal = this.injector.get('$uibModal');
        this.usersStore = this.injector.get('Users');
        this.depositService = this.injector.get('Deposit');
        this.acl = this.injector.get('Acl');

        this.glTemplateStatesForSelect = [];
        this.rsvpStates = {};

        this.loading = true;

        this.templateId = null;
        this.guestlistId = null;
        this.availableGlTemplateStates = [];
        this.cancelTrigger = null;

        this.dataChanged = false;
        this.editEnabled = false;

        this.originalTemplate = null;
        this.templateModel = null;
        this.originalTemplateModel = null;

        this.guestlistTemplate = null;
        this.originalGuestlistTemplate = null;
        this.templatePreviewImageUrl = null;

        this.templateRelationsToDelete = [];

        this._loadDeposits();
    }


    $onInit() {
        this._prepareTemplatePreviewImage();
        this._loadData()
            .then(() => {
                this._prepareGlTemplateStatesForSelect();
                this.loading = false;
            });

        this._initWatchers();

        this.cancelTrigger = () => {
            return this.cancelEdit(true);
        }
    }

    onFileSelect(field, selectedFile) {
        _.set(this.templateModel, field, _.get(selectedFile, 'uuid', null));
    }

    submit(form) {
        if (!form.$valid) {
            this.alert.animatedAlert(
                this.translate.instant('general.alerts.data_invalid.title'),
                this.translate.instant('general.alerts.data_invalid.content'),
                'attention',
                {
                    showCancelButton: false,
                    confirmButtonText: this.translate.instant('general.verbs.ok')
                }
            );
            return;
        }
        this.submitting = true;

        this._saveTemplate()
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.change_save_success.title'),
                    this.translate.instant('general.alerts.change_save_success.content')
                );
                this.submitting = false;

                this.onSave();
            })
            .catch(() => {
                this.alert.warning(
                    this.translate.instant('general.alerts.change_save_error.title'),
                    this.translate.instant('general.alerts.change_save_error.content')
                );
                this.submitting = false;

                this.onError();
            });
    }

    _saveTemplate() {
        return this.api.put(`templates/${this.templateId}/meta`, this.templateModel)
            .then(({data}) => {
                return new Promise((resolve, reject) => {
                    if (this.guestlistTemplate) {
                        this._saveGuestlistTemplate().finally(() => {
                            resolve();
                        });
                        return;
                    }

                    resolve();
                }).then(() => {
                    this._loadData()
                        .then(() => {
                            this._prepareGlTemplateStatesForSelect();
                            this.loading = false;
                        });
                })
            });
    }

    _saveGuestlistTemplate() {
        return this.api.put(`guestlists/${this.guestlistTemplate.guestlist_id}/templates/${this.guestlistTemplate.id}`, {
            status: this.guestlistTemplate.status
        })
            .then(({data}) => {
                this.guestlistTemplate = data.data;
            })
    }

    deleteGuestlistRelation(guestlistTemplate) {
        this.alert.animatedAlert(
            this.translate.instant(
                'templates.components.al-email-template-editor.alerts.ask-for-deleting-guestlist-relation.title',
                {
                    guestlist_name: guestlistTemplate.guestlist.name
                }
            ),
            this.translate.instant(
                'templates.components.al-email-template-editor.alerts.ask-for-deleting-guestlist-relation.content',
                {
                    guestlist_name: guestlistTemplate.guestlist.name
                }
            ),
            'attention',
            {
                cancelButtonText: this.translate.instant('general.buttons.cancel'),
                confirmButtonText: this.translate.instant('general.verbs.yes')
            }
        ).then(() => {
            this.api.delete(`guestlists/${guestlistTemplate.guestlist_id}/templates/${guestlistTemplate.id}`)
                .then(() => {
                    this.alert.info(
                        this.translate.instant('templates.components.al-email-template-editor.alerts.guestlist-relation-deleted.title'),
                        this.translate.instant('templates.components.al-email-template-editor.alerts.guestlist-relation-deleted.content')
                    )

                    this.originalTemplate.guestlist_links = _.filter(this.originalTemplate.guestlist_links, (glTemplate) => {
                        return glTemplate.id !== guestlistTemplate.id;
                    });
                });
        })
    }

    cancelEdit(noEventTrigger) {
        return new Promise((resolve, reject) => {
            if (!this.dataChanged) {
                if (!noEventTrigger) {
                    this.onCancel();
                }
                resolve();
                return;
            }

            this.alert.animatedAlert(
                this.translate.instant('general.alerts.ask-for-cancel-without-saving-changes.title'),
                this.translate.instant('general.alerts.ask-for-cancel-without-saving-changes.content'),
                'attention',
                {
                    confirmButtonText: this.translate.instant('general.alerts.ask-for-cancel-without-saving-changes.confirm'),
                    cancelButtonText: this.translate.instant('general.alerts.ask-for-cancel-without-saving-changes.cancel')
                }
            ).then(() => {
                if (!noEventTrigger) {
                    this.onCancel();
                }
                resolve();
            }).catch(() => {
                reject();
            });
        })
    }

    openPreviewModel() {
        templatePreviewStarter(this.injector, this.originalTemplate, this.guestlistId)
            .then(() => {
            })
            .catch(() => {
            });
    }

    editBeefreeTemplate() {
        this.modal.open({
            controller: AlEmailTemplateEditorBeefreeModalController,
            controllerAs: 'vm',
            templateUrl: beefreeModalTemplate,
            size: 'xlg',
            windowClass: 'modal-fixed',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                originalTemplate: () => {
                    return this.originalTemplate;
                },
                guestlistTemplate: () => {
                    return this.guestlistTemplate;
                }
            }
        }).result
            .then(({json, html}) => {
                this.originalTemplate.beefree_json = json;
                this.originalTemplate.html = html;
                this._prepareTemplatePreviewImage();
            })
            .catch(() => {

            })
    }

    _loadData() {
        return new Promise((resolve, reject) => {
            this.api.get(`templates/${this.templateId}`)
                .then(({data}) => {
                    this.originalTemplate = data.data;
                    this._checkEditEnabled();
                    this.templateModel = templateModelReducer(this.originalTemplate);
                    delete this.templateModel.beefree_json;
                    delete this.templateModel.html;
                    this.originalTemplateModel = _.cloneDeep(this.templateModel);

                    if (!this.guestlistId) {
                        resolve();
                        return;
                    }

                    const availableGuestlistTemplate = _.first(_.filter(this.originalTemplate.guestlist_links, guestlistLink => (guestlistLink.guestlist_id === this.guestlistId)));

                    if (!availableGuestlistTemplate) {
                        resolve();
                        return;
                    }

                    this.api.get(`guestlists/${this.guestlistId}/templates/${availableGuestlistTemplate.id}`)
                        .then(({data}) => {
                            this.guestlistTemplate = data.data;
                            this.originalGuestlistTemplate = _.cloneDeep(this.guestlistTemplate);
                            resolve();
                        })
                        .catch(() => {
                            resolve();
                        });
                })
                .catch((e) => {
                    this.alert.animatedAlert(
                        this.translate.instant('general.alerts.not_found.title'),
                        this.translate.instant('general.alerts.not_found.content'),
                        'attention', {
                            showCancelButton: false,
                            confirmButtonText: this.translate.instant('general.verbs.ok')
                        }
                    );
                    this.onError({
                        error: 'template_not_found'
                    })
                })
        });
    }

    _prepareTemplatePreviewImage() {
        this.templatePreviewImageUrl = null;

        if (!this.templateId) {
            return;
        }

        templatePreviewLoader(this.injector, this.templateId)
            .then((dataUrl) => {
                this.templatePreviewImageUrl = dataUrl;
            })
            .catch(error => {
            });
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.availableGlTemplateStates;
        }, () => {
            this._prepareGlTemplateStatesForSelect();
        })

        this.scope.$watch(() => {
            return this.templateModel;
        }, () => {
            this._checkDataChanged();
        }, true)

        this.scope.$watch(() => {
            return this.guestlistTemplate;
        }, () => {
            this._checkDataChanged();
        }, true)
    }

    _prepareGlTemplateStatesForSelect() {
        this.glTemplateStatesForSelect = {
            '': 'No status'
        };

        _.each(
            this.rsvpStates,
            (label, status) => {
                if (
                    (
                        this.availableGlTemplateStates
                        && this.availableGlTemplateStates.indexOf(status) === -1
                    )
                    && (
                        this.guestlistTemplate
                        && this.guestlistTemplate.status !== status
                    )
                ) {
                    return;
                }
                this.glTemplateStatesForSelect[status] = label;
            }
        );
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('rsvps', 'states').then((result) => {
            this.rsvpStates = result;
        })
    }

    _checkDataChanged() {
        this.dataChanged = !angular.equals(this.templateModel, this.originalTemplateModel)
            || !angular.equals(this.guestlistTemplate, this.originalGuestlistTemplate);
    }

    _checkEditEnabled() {
        this.editEnabled = !this.originalTemplate.archived
            && this.acl.hasRight('templates::edit');
    }
}

AlEmailTemplateEditorController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/templates/components/al-email-template-editor/controller.js